import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import './Hero.css';
import culinary from './hero1.jpg';
import vr from './hero2.jpg';
import farm from './farm.jpg';
import hiking from './hiking.jpg';
import car from './car.jpg';

const images = [culinary, vr, farm, hiking, car];

const badgeDetails = [
  {
    name: "The Flavor Hunter",
    description: "For those who chase spices, stories, and secret recipes."
  },
  {
    name: "Mind-Bender Explorer",
    description: "Reality? Overrated. You see dimensions the rest of us dream about."
  },
  {
    name: "Harvest Hopper",
    description: "You don't shop—you forage with flair and local love."
  },
  {
    name: "Trail Whisperer",
    description: "Your footprints belong in poetry and pine needles."
  },
  {
    name: "Roam Commander",
    description: "You live off maps, detours, and unforgettable playlists."
  }
];

const links = [
  '/destinations/culinary-tours',
  '/destinations/vr-2',
  '/destinations/farmers-markets',
  '/destinations/nature-hikes',
  '/destinations/outdoor-adventures'
];

export default function HeroSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      handleSlideChange((currentIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  const handleSlideChange = (newIndex) => {
    setTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(newIndex);
      setTransitioning(false);
    }, 300);
  };

  const goToPreviousSlide = () => {
    handleSlideChange((currentIndex - 1 + images.length) % images.length);
  };

  const goToNextSlide = () => {
    handleSlideChange((currentIndex + 1) % images.length);
  };

  return (
    <div className="hero-section">
      {/* Main Slides */}
      <div className="hero-slides-container">
        {images.map((image, index) => (
          <div 
            key={index}
            className={`hero-slide ${index === currentIndex ? 'active' : ''} ${transitioning ? 'transitioning' : ''}`}
            style={{ 
              backgroundImage: `url(${image})`,
              zIndex: index === currentIndex ? 5 : 4 - Math.abs(currentIndex - index)
            }}
          >
            <div className="slide-overlay" />
          </div>
        ))}
      </div>
      
      {/* Content */}
      <div className={`hero-content ${transitioning ? 'fade-out' : 'fade-in'}`}>
        <h3 className="hero-title">
          {badgeDetails[currentIndex].name}
        </h3>
        <p className="hero-description">
          {badgeDetails[currentIndex].description}
        </p>

        <Link to={links[currentIndex]} className="hero-link">
          <button className="hero-button">
            <span>Explore</span>
            <ArrowRight className="hero-button-icon" />
          </button>
        </Link>
      </div>
      
      {/* Thumbnail Grid */}
      <div className="thumbnail-grid">
        {images.map((image, index) => (
          <div 
            key={index}
            className={`thumbnail mt-5 ${index === currentIndex ? 'active' : ''}`}
            onClick={() => handleSlideChange(index)}
          >
            <div 
              className="thumbnail-image"
              style={{ backgroundImage: `url(${image})` }}
            />
            <div className="thumbnail-overlay" />
            <div className="thumbnail-badge">{badgeDetails[index].name}</div>
          </div>
        ))}
      </div>
      
      {/* Indicators */}
      <div className="slide-indicators">
        {images.map((_, index) => (
          <div 
            key={index}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => handleSlideChange(index)}
          />
        ))}
      </div>
      
      {/* Controls */}
      <button 
        className="control-btn prev-btn"
        onClick={goToPreviousSlide}
        aria-label="Previous Slide"
      >
        <ArrowLeft />
      </button>
      <button 
        className="control-btn next-btn"
        onClick={goToNextSlide}
        aria-label="Next Slide"
      >
        <ArrowRight />
      </button>
    </div>
  );
}